module.exports = __webpack_public_path__ + "static/media/Evil Wizard.6ece6d6c.jpg";